import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../lib/theme";

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 38,
        height: 38,
        borderRadius: 999,
        border: "1px solid hsl(var(--line))",
        background: "hsl(var(--bg-elev))",
        color: "hsl(var(--ink))",
        cursor: "pointer",
        transition: "border-color 160ms ease, color 160ms ease",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "hsl(var(--accent))"; e.currentTarget.style.color = "hsl(var(--accent))"; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "hsl(var(--line))"; e.currentTarget.style.color = "hsl(var(--ink))"; }}
    >
      {isDark ? <Sun size={16} aria-hidden /> : <Moon size={16} aria-hidden />}
    </button>
  );
};
